import stripeActions from './stripe'
import receiptActions from './receipt'
import userActions from './user'

export default {
  ...stripeActions,
  ...receiptActions,
  ...userActions,
}
